import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

// Define routes with metadata
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/DashboardView.vue'),
    meta: {
      title: '我的人工智能总览仪表板',
      keepAlive: true // Enable caching for this route
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: '关于'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: {
      title: '我的人工智能总览仪表板',
      keepAlive: true // Enable caching for this route
    }
  },
]

// Create router instance
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Global navigation guard to update document title based on route meta
router.beforeEach((to, from, next) => {
  // Update document title
  const title = to.meta.title ? `${to.meta.title}` : '我的人工智能总览仪表板'
  document.title = title
  
  // Continue navigation
  next()
})

export default router
